import Store from 'store/store'
import { Component } from 'utils/jsx'
import Rectangle from 'abstractions/Rectangle'

import Paragraph from 'components/paper/Paragraph'

export default class Signature extends Component {
  beforeRender ({
    x = 0, // unitless
    y = 0, // unitless
    height = 0, // unitless
    width = 0, // unitless,
    color = undefined,
    origin = 'NW'
  } = {}) {
    this.state = {
      rectangle: new Rectangle({ x, y, width, height, origin })
    }
  }

  template (props) {
    const region = Store.regions.get().find(r => r.selected)
    if (!region || !region.signature) return

    const CHAR_WIDTH = Paragraph.charWidth({
      font: Store.poster.fonts.current['Space Mono'],
      fontSize: props.fontSize
    })

    const MARGIN = CHAR_WIDTH * 5

    const paragraphs = []
    // We do a reverse iteration because Signature is composed from right to left
    for (let x = props.x, index = region.signature.length - 1; index >= 0; index--) {
      const value = region.signature[index]
      const lines = value.split('\n')
      const maxLength = Math.max(...lines.map(line => line.length))
      const width = (maxLength + 1) * CHAR_WIDTH

      // Do not draw Paragraph if it overflows the Signature rectangle
      if (x - width <= this.state.rectangle.x) continue

      paragraphs.push(
        <Paragraph
          color={props.color}
          x={x}
          y={props.y}
          origin={props.origin}
          width={width}
          verticalOffset={0}
          height={props.fontSize * lines.length}
          fontSize={props.fontSize}
        >
          {value}
        </Paragraph>
      )

      x -= width + MARGIN
    }

    return <g class='signature'>
      {paragraphs}
      {this.state.rectangle.vnode({ class: 'guide bbox no-export' })}
    </g>
  }
}



// WEBPACK FOOTER //
// ./src/components/paper/Signature.js